(() => {
  document.documentElement.classList.add('js');

  const selectors = {
    quickAdd: '[data-quick-add]',
    cartCount: '.site-header__cart-count',
    cartLink: '.site-header__cart',
    productQty: '[data-cart-product-qty]',
    cartPage: '[data-cart-page]',
    cartItem: '[data-cart-item]',
    cartStatus: '[data-cart-status]',
    cartContent: '[data-cart-content]',
    cartEmpty: '[data-cart-empty]',
    cartTotal: '[data-cart-total]',
    cartItemsTotal: '[data-cart-items-total]',
    facetsDrawer: '[data-facets-drawer]'
  };

  const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
    style: 'currency',
    currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
  });

  const formatMoney = (cents) => moneyFormatter.format((Number(cents) || 0) / 100);

  const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((response) => response.json());

  const setStatus = (message, isError = false) => {
    document.querySelectorAll(selectors.cartStatus).forEach((status) => {
      status.textContent = message || '';
      status.classList.toggle('is-error', Boolean(isError));
      status.classList.toggle('is-visible', Boolean(message));
    });
  };

  const updateHeaderCount = (itemCount) => {
    const cartLink = document.querySelector(selectors.cartLink);
    if (!cartLink) return;

    let count = cartLink.querySelector(selectors.cartCount);
    if (itemCount > 0) {
      if (!count) {
        count = document.createElement('span');
        count.className = 'site-header__cart-count';
        cartLink.appendChild(count);
      }
      count.textContent = itemCount;
    } else if (count) {
      count.remove();
    }
  };

  const updateProductBadges = (cart) => {
    const quantities = {};
    cart.items.forEach((item) => {
      quantities[item.product_id] = (quantities[item.product_id] || 0) + item.quantity;
    });

    document.querySelectorAll(selectors.productQty).forEach((badge) => {
      const productId = badge.getAttribute('data-cart-product-qty');
      const quantity = quantities[productId] || 0;
      badge.textContent = quantity;
      badge.classList.toggle('is-hidden', quantity === 0);
    });
  };

  const updateCartPage = (cart) => {
    const cartPage = document.querySelector(selectors.cartPage);
    if (!cartPage) return;

    const content = cartPage.querySelector(selectors.cartContent);
    const empty = cartPage.querySelector(selectors.cartEmpty);
    content?.classList.toggle('is-hidden', cart.item_count === 0);
    empty?.classList.toggle('is-hidden', cart.item_count > 0);

    cartPage.querySelectorAll(selectors.cartItem).forEach((row) => {
      const key = row.getAttribute('data-cart-key');
      const item = cart.items.find((cartItem) => cartItem.key === key);
      if (!item) {
        row.remove();
        return;
      }
      const quantity = row.querySelector('[data-cart-quantity]');
      const linePrice = row.querySelector('[data-cart-line-price]');
      if (quantity) quantity.textContent = item.quantity;
      if (linePrice) linePrice.textContent = formatMoney(item.final_line_price);
    });

    const itemsTotal = cartPage.querySelector(selectors.cartItemsTotal);
    const total = cartPage.querySelector(selectors.cartTotal);
    if (itemsTotal) itemsTotal.textContent = formatMoney(cart.items_subtotal_price);
    if (total) total.textContent = formatMoney(cart.total_price);
  };

  const syncCartUi = (cart) => {
    updateHeaderCount(cart.item_count);
    updateProductBadges(cart);
    updateCartPage(cart);
  };

  const refreshCartUi = () => fetchCart().then(syncCartUi).catch(() => {});

  const setButtonLoading = (button, loading) => {
    button.disabled = loading;
    button.classList.toggle('is-loading', loading);
  };

  document.addEventListener('click', (event) => {
    const facetsOpen = event.target.closest('[data-facets-open]');
    if (facetsOpen) {
      const drawer = document.querySelector(selectors.facetsDrawer);
      if (drawer) {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('facets-open');
      }
      return;
    }

    if (event.target.closest('[data-facets-close]')) {
      const drawer = document.querySelector(selectors.facetsDrawer);
      if (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('facets-open');
      }
      return;
    }

    const quickButton = event.target.closest(selectors.quickAdd);
    if (quickButton) {
      event.preventDefault();
      const variantId = quickButton.getAttribute('data-variant-id');
      if (!variantId || quickButton.disabled) return;

      setStatus('');
      setButtonLoading(quickButton, true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then((response) => {
          if (!response.ok) throw new Error('add_failed');
          return fetchCart();
        })
        .then((cart) => {
          syncCartUi(cart);
          quickButton.classList.add('is-added');
          quickButton.querySelector('.product-card__quick-add-text')?.replaceChildren(document.createTextNode('Aggiunto'));
          window.setTimeout(() => {
            quickButton.classList.remove('is-added');
            quickButton.querySelector('.product-card__quick-add-text')?.replaceChildren(document.createTextNode('Aggiungi'));
          }, 1400);
        })
        .catch(() => {
          setStatus('Non siamo riusciti ad aggiungere il prodotto. Riprova tra poco.', true);
          quickButton.classList.add('is-error');
          window.setTimeout(() => quickButton.classList.remove('is-error'), 1400);
        })
        .finally(() => setButtonLoading(quickButton, false));

      return;
    }

    const cartButton = event.target.closest('[data-cart-change], [data-cart-remove]');
    if (!cartButton) return;

    const row = cartButton.closest(selectors.cartItem);
    if (!row) return;

    const key = row.getAttribute('data-cart-key');
    const currentQuantity = Number(row.querySelector('[data-cart-quantity]')?.textContent || 0);
    const nextQuantity = cartButton.hasAttribute('data-cart-remove')
      ? 0
      : Math.max(0, currentQuantity + Number(cartButton.getAttribute('data-delta') || 0));

    setStatus('');
    row.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: nextQuantity })
    })
      .then((response) => {
        if (!response.ok) throw new Error('change_failed');
        return response.json();
      })
      .then((cart) => {
        syncCartUi(cart);
        if (nextQuantity === 0) setStatus('Prodotto rimosso dal carrello.');
      })
      .catch(() => setStatus('Non siamo riusciti ad aggiornare il carrello. Riprova tra poco.', true))
      .finally(() => row.classList.remove('is-updating'));
  });

  document.addEventListener('change', (event) => {
    const sortSelect = event.target.closest('[data-sort-select]');
    if (sortSelect) {
      sortSelect.form?.submit();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const drawer = document.querySelector(selectors.facetsDrawer);
    if (drawer?.classList.contains('is-open')) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('facets-open');
    }
  });

  refreshCartUi();
})();
